<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showRequestClaim"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed center-h-v bg-white rounded-md shadow-2xl sm:w-1/2 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div class="flex justify-between items-center border-b-1.5 p-3">
            <p class="text-base">Raise Claim</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <div class="grid grid-cols-2 p-4 gap-3">
            <div class="text-sm">
              <label class="block pb-1">Claim Type</label>
              <select
                required
                class="p-2 bg-gray-200 rounded-full w-full"
                v-model="selectedClaimType"
                @click="getClaimTypes"
              >
                <option v-for="(ClaimType, index) in ClaimTypes" :key="index">
                  {{ ClaimType.Name }}
                </option>
              </select>
            </div>
            <div class="text-sm">
              <label class="block pb-1">Date of Expense</label>
              <input
                v-model="info.DateApplied"
                value="info.StartDate"
                type="date"
                :max="new Date().toISOString().split('T')[0]"
                class="p-2 bg-gray-200 rounded-full w-full"
                placeholder="Claim Type"
                required
              />
            </div>
          </div>
          <div class="text-sm p-4">
            <label class="block pb-1">Amount</label>
            <input
              class="p-2 bg-gray-200 rounded-full w-full disabled border-0.5"
              v-model="info.Amount"
              required
            />
          </div>
          <div class="p-4">
            <label>Attachment</label>
            <input
              v-on:change="getFile"
              type="file"
              accept=".pdf,image/jpeg,image/png"
              class="p-2 bg-gray-200 rounded-full w-full"
              placeholder="Claim Type"
            />
          </div>
          <div class="p-4">
            <label>Description</label>
            <textarea
              v-model="info.Description"
              class="p-1 bg-gray-200 rounded-xl w-full"
              cols="5"
            ></textarea>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </transition>
    <!-- <leave-date-picker></leave-date-picker> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";
import axios from "axios";

export default {
  name: "RequestClaim",
  props: ["showRequestClaim", "raiseClaimCallback"],
  components: {
    Loader,
  },
  data() {
    return {
      create_error: null,
      loading: false,
      inputDisabled: true,
      currentDate: null,
      dateError: false,
      selectedDate: null,
      policyDays: null,

      ClaimTypes: [],
      selectedClaimType: null,
      info: {
        ClaimType: null,
        DateApplied: null,
        Amount: null,
        Attachment: null,
        Description: null,
      },
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId"]),

    ClaimTypeID() {
      if (this.selectedClaimType) {
        const claim = this.ClaimTypes.find(
          (claim) =>
            claim.Name.trim().toLowerCase() ===
            this.selectedClaimType.trim().toLowerCase()
        );
        return claim.Id;
      }

      return null;
    },
  },
  created() {
    this.getClaimTypes();
  },
  watch: {},
  methods: {
    close() {
      this.$emit("close");
      (this.info = {
        ClaimType: null,
        DateApplied: null,
        Amount: null,
        Attachment: null,
        Description: null,
      }),
        (this.selectedClaimType = null);
    },
    getFile({ target }) {
      const file = target.files[0];
      this.info.Attachment = file;
    },

    // /{organization}/setup/claim/type/v1/request
    getClaimTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/claim/type/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.ClaimTypes = response.data.Data;
              //console.log(this.ClaimTypes)
            }
          },
          () => {
            this.loading = false;
          }
        );
    },

    // /{organization}/employee/claim/v1/create
    create() {
      this.info.ClaimType = this.ClaimTypeID;
      const formData = new FormData();
      formData.append("EmployeeId", this.getCurrentEmployeeId);
      formData.append("ClaimTypeId", this.info.ClaimType);
      formData.append("DateApplied", this.info.DateApplied);
      formData.append("Amount", this.info.Amount);
      formData.append("Attachment", this.info.Attachment);
      formData.append("Description", this.info.Description);

      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      };
      axios
        .post(
          `${this.getOrganization}/employee/claim/${this.$ApiVersion}/create`,
          formData,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.ClaimTypes = response.data.Data;

              this.$emit("closeOnSuccess");
              this.info = {
                ClaimType: null,
                StartDate: null,
                Period: null,
                date: null,
                EndDate: null,
                Attachment: "",
                Description: "",
              };
              this.selectedClaimType = null;
              this.raiseClaimCallback(response.data.StatusMessage, false);
            } else {
              this.create_error = response.data.StatusMessage;
              this.raiseClaimCallback(response.data.StatusMessage, true);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            this.raiseClaimCallback(error.message, true);
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
